// src/components/pendenzen/TopbarPendenzen.jsx
import React, { useEffect, useId, useState } from "react";
import { ClipboardCheck } from "lucide-react";
import PendenzenQuickList from "./PendenzenQuickList.jsx";
import { PendenzenAPI } from "../../constants/api";
import { useTheme } from "../../context/ThemeContext.jsx";
import AppButton from "../ui/AppButton.jsx";
export default function TopbarPendenzen({
  currentUser
}) {
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(0);
  const panelId = useId();
  const myId = Number(currentUser?.id) || null;

  // einmal beim Mount laden + gelegentlich aktualisieren (sichtbar)
  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const d = await PendenzenAPI.listMine({
          status: "offen",
          pageSize: 1,
        });
        if (!alive) return;
        const total = Number(d?.total);
        if (Number.isFinite(total) && total >= 0) {
          setCount(total);
          return;
        }
        const items = d?.items || [];
        const mine = myId == null ? items : items.filter(x => Number(x.assignee_id) === myId);
        setCount(mine.filter(x => x.status === "offen").length);
      } catch {}
    };
    load();
    const onVis = () => {
      if (document.visibilityState === "visible") load();
    };
    document.addEventListener("visibilitychange", onVis);
    const t = window.setInterval(() => {
      if (document.visibilityState === "visible") load();
    }, 30_000);
    return () => {
      alive = false;
      clearInterval(t);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, [myId]);

  // beim Navigieren Panel schließen
  useEffect(() => {
    const onNav = () => setOpen(false);
    window.addEventListener("popstate", onNav);
    window.addEventListener("hashchange", onNav);
    return () => {
      window.removeEventListener("popstate", onNav);
      window.removeEventListener("hashchange", onNav);
    };
  }, []);
    const badge = count > 99 ? "99+" : count;
  return <div className="relative">
      <AppButton onClick={e => {
      e.stopPropagation();
      setOpen(v => !v);
    }} variant="ghost" className={["relative inline-flex items-center justify-center h-10 w-10 rounded-xl min-h-[44px] min-w-[44px] md:min-h-0 md:min-w-0", "border transition-all focus:outline-none focus:ring-2 focus:ring-blue-400/50", open ? "icon-btn-active" : "icon-btn-surface"].join(" ")} title="Pendenzen" aria-haspopup="dialog" aria-expanded={open} aria-controls={panelId} aria-label="Pendenzen öffnen" data-pend-anchor type="button">
        <ClipboardCheck size={18} className={""} />
        {count > 0 && <span className="absolute -top-1 -right-1 min-w-[20px] h-[20px] px-1 grid place-items-center
             rounded-full bg-blue-600 text-white text-[10px] border border-white/30">
            {badge}
          </span>}
        <span className="sr-only" aria-live="polite">
          {count > 0 ? `${count} offene Pendenzen` : "Keine offenen Pendenzen"}
        </span>
      </AppButton>

      <PendenzenQuickList id={panelId} open={open} onClose={() => setOpen(false)} currentUser={currentUser} />
    </div>;
}